/* esm.sh - react-router@8.4.0/dist/production/lib/router/navigation */
var s=new URL("http://localhost");function f(t){if(t.createURL)return t.createURL("/");try{return new URL(t.createHref("/"),s)}catch{return s}}function o(t,e){return t.origin===e.origin&&(t.origin!=="null"||t.protocol===e.protocol&&t.host===e.host)}function u(t,e){if(t.startsWith("//"))return!0;let r=e.protocol.toLowerCase();return t.toLowerCase().startsWith(r)?e.host===""||t.slice(r.length).startsWith("//"):!1}function h(t,e,r,a){let l=null;try{l=t==null?null:new URL(t,r)}catch{}let n=new URL(e,r),c=l!=null&&!o(l,r),i=!o(n,r);if(a==="reject"){if(c||i)throw new Error("External navigation is not allowed")}else if(i&&(l==null||!u(t,l)||!o(l,n)))throw new Error("External navigation is not allowed")}export{f as getNavigatorCurrentUrl,h as validateNavigationTarget};
/*! Bundled license information:

react-router/dist/production/lib/router/navigation.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=navigation.mjs.map